import type { Agent } from "../types";

function deploymentVersion(version?: number | string | null): number {
	if (typeof version === "number" && Number.isFinite(version)) return version;
	if (typeof version === "string") {
		const normalized = version.trim().match(/\d+/)?.[0];
		const parsed = normalized ? Number.parseInt(normalized, 10) : Number.NaN;
		return Number.isFinite(parsed) ? parsed : 0;
	}
	return 0;
}

export function hasSuccessfulTestingDeployment(agent: Agent): boolean {
	return (
		agent.stagingDeployment?.status?.toLowerCase() === "deploy_success" &&
		deploymentVersion(agent.stagingDeployment.version) > 0
	);
}
